/**
 * Prefix passed to react-jsonschema-from as idPrefix attribute.
 */
export const RJSF_CUSTOM_PREFIX: string = 'rjsf_prefix';

// to faciliate local cloud desktop testing
// the URL above needs to be replaced by your developer desktop domain
export const CLOUD_DEV_DESKTOP: string = 'guillotb.aka.corp.amazon.com';
export const LOCALHOST: string = '0.0.0.0';

/**
 * Error type in transform error functions.
 */
export const REQUIRED_ERROR: string = "required";
export const PATTERN_ERROR: string = "pattern";
export const TYPE_ERROR: string = "type";
export const ENUM_ERROR: string = "enum";

export const ON_CHANGE_EVENT = "onChange";

export const HTML_ELEMENT_DIV = "div";

export const HIDE_ERROR_FLAG = "HIDE_ERROR_FLAG";

export const NUMBER = "number";
export const TEXT = "text";
export const URL = "url";

export const PRODUCTION = "production";

export const LINK_API_HELP = "https://developer.amazon.com/docs/amazon-pay-api-v2/introduction.html";
export const LINK_SCRATCHPAD_HELP = "https://developer.amazon.com/docs/amazon-pay-checkout/scratchpad.html";
export const LINK_SCRATCHPAD_HELP_JP = "https://developer.amazon.com/ja/docs/amazon-pay-checkout/scratchpad.html";
export const LINK_GET_SECURITY_CREDENTIALS = "https://developer.amazon.com/docs/amazon-pay-checkout/get-set-up-for-integration.html#5-get-your-public-key-id";
export const HTTPS = "https://";
export const PAY_API ="pay-api.amazon";
export const US_HOST=".com";
export const EU_HOST =".eu";
export const JP_HOST =".jp";
export const SCRATCHPAD_URI = "/tools/scratchpad/index.html";

export const regionMapping = {
    us : 'na',
    na : 'na',
    eu : 'eu',
    jp : 'fe'
};

export const marketplaceMapping = {
    na: "USAmazon",
    eu: "EUAmazon",
    jp: "JPAmazon"
};

// code elsewhere will default to EU region
export const hostMapping = {
    "pay-api.amazon.com" : "na",
    "pay-api-preprod-iad.iad.proxy.amazon.com" : "na",
    "pay-api.integ.amazon.com" : "na",
    "pay-api.amazon.jp" : "jp",
    "pay-api-jp-preprod-pdx.pdx.proxy.amazon.com" : "jp",
    "pay-api-jp.integ.amazon.com" : "jp",
};
hostMapping[CLOUD_DEV_DESKTOP] = "na";

export const REGIONS = [
    { name: "US", value: "na" },
    { name: "EU/UK", value: "eu" },
    { name: "JP", value: "jp" }
];

export const PLACEMENT = "placement";

export enum placement {
    HOME = "Home",
    PRODUCT = "Product",
    CART = "Cart",
    CHECKOUT = "Chekout",
    OTHER = "Other"
};

export const PUBLIC_KEY_ID = "publicKeyId"
export const MERCHANT_ID = "merchantId";
export const LEDGER_CURRENCY = "ledgerCurrency";
export const ADDRESS_DETAILS = "addressDetails";
export const PROVIDER_METADATA = "providerMetadata";
export const MERCHANT_METADATA = "merchantMetadata";
export const RECURRING_METADATA = "recurringMetadata";
export const PAYMENT_INTENT = "paymentIntent";
export const STORE_ID = "storeId";
export const WEB_CHECKOUT_DETAILS = "webCheckoutDetails";
export const PLATFORM_ID = "platformId";
export const CHARGE_PERMISSION_TYPE = "chargePermissionType";
export const CUSTOM = "customKatInput";
export const PRODUCT_TYPE = "productType";
export const CHECKOUT_LANGUAGE = "checkoutLanguage";
export const BUTTON_COLOR = "buttonColor";
export const BUTTON_DESIGN = "design";
export const BUTTON_HEIGHT = "buttonHeight";
export const BUTTON_WIDTH = "buttonWidth";
export const CREATE_CHECKOUT_SESSION_CONFIG = "createCheckoutSessionConfig";
export const SIGN_IN_CONFIG = "signInConfig";
export const PAYMENT_DETAILS = "paymentDetails";
export const PROCESS_ORDER = "ProcessOrder";
export const DELIVERY_SPECIFICATIONS_HINT = '{"specialRestrictions": ["RestrictPOBoxes"], "addressRestrictions": {"type": "Allowed", "restrictions": {"US": {"statesOrRegions": ["WA"] }}}}';
export const DELIVERY_SPECIFICATIONS = "deliverySpecifications";
export const SCOPES = "scopes";
export const SIGN_IN_SCOPES_HINT = "name, email, phoneNumber, shippingAddress, billingAddress, postalCode";
export const CHECKOUT_SCOPES_HINT = "name, email, phoneNumber, billingAddress";
export const PAYMENT_METHOD_ON_FILE_METADATA = "paymentMethodOnFileMetadata";
export const CHANNEL = "channel";
export const CHARGE_INITIATOR = "chargeInitiator";
export const CHARGE_PERMISSION_ID = "chargePermissionId";

export enum webCheckoutDetails {
    CHECKOUT_REVIEW_RETURN_URL = "checkoutReviewReturnUrl",
    CHECKOUT_RESULT_RETURN_URL = "checkoutResultReturnUrl",
    CHECKOUT_CANCEL_URL = "checkoutCancelUrl",
    CHECKOUT_MODE = "checkoutMode"
};

export enum recurringMetadata {
    FREQUENCY = "frequency",
    AMOUNT = "amount"
};

export enum paymentMethodOnFileMetadata {
    SETUP_ONLY = "setupOnly"
}

export enum addressDetails {
    NAME = "name",
    ADDRESS_LINE_1 = "addressLine1",
    ADDRESS_LINE_2 = "addressLine2",
    ADDRESS_LINE_3 = "addressLine3",
    CITY = "city",
    DISTRICT_OR_COUNTY = "districtOrCounty",
    STATE_OR_REGION = "stateOrRegion",
    POSTAL_CODE = "postalCode",
    COUNTRY_CODE = "countryCode",
    PHONE_NUMBER = "phoneNumber"
};

export enum merchantMetadata {
    MERCHANT_REFERENCE_ID = "merchantReferenceId",
    MERCHANT_STORE_NAME = "merchantStoreName",
    NOTE_TO_BUYER = "noteToBuyer",
    CUSTOM_INFORMATION = "customInformation"
};

export enum paymentDetails {
    PAYMENT_INTENT = "paymentIntent",
    CAN_HANDLE_PENDING_AUTHORIZATION = "canHandlePendingAuthorization",
    CHARGE_AMOUNT = "chargeAmount",
    TOTAL_ORDER_AMOUNT = "totalOrderAmount",
    PRESENTMENT_CURRENCY = "presentmentCurrency",
    SOFT_DESCRIPTOR = "softDescriptor",
    ALLOW_OVERCHARGE = "allowOvercharge",
    EXTEND_EXPIRATION = "extendExpiration"
};

export enum providerMetadata {
    PROVIDER_REFERENCE_ID = "providerReferenceId"
};

export enum signIn {
    SIGN_IN_RETURN_URL = "signInReturnUrl",
    SIGN_IN_CANCEL_URL = "signInCancelUrl",
    STORE_ID = "storeId",
    SIGN_IN_SCOPES = "signInScopes"
};

export enum frequency {
    UNIT = "unit",
    VALUE = "value"
};

export enum amount {
    AMOUNT = "amount",
    CURRENCY_CODE = "currencyCode"
};

export enum PayButton {
    BUTTON_TYPE = "buttonType",
    BUTTON_OPTION = "buttonOption",
    BUTTON_RENDER = "buttonRender"
};

export enum ChargePermissionTypes {
    ONE_TIME = "OneTime",
    RECURRING = "Recurring",
    PAYMENT_METHOD_ON_FILE = "PaymentMethodOnFile"
};

export enum ButtonTypes {
    ONE_TIME = "One-time Purchase",
    RECURRING = "Recurring Purchase",
    APB_ONE_TIME = "Additional Payment Button (One-time)",
    APB_RECURRING = "Additional Payment Button (Recurring)",
    AMAZON_SIGN_IN = "Amazon Sign-in",
    PAYMENT_METHOD_ON_FILE = "Payment Method On File"
};

export const BUTTON_TYPES = [
    { name: ButtonTypes.ONE_TIME, value: ButtonTypes.ONE_TIME },
    { name: ButtonTypes.RECURRING, value: ButtonTypes.RECURRING },
    { name: ButtonTypes.APB_ONE_TIME, value:  ButtonTypes.APB_ONE_TIME},
    { name: ButtonTypes.APB_RECURRING, value:  ButtonTypes.APB_RECURRING},
    { name: ButtonTypes.AMAZON_SIGN_IN, value: ButtonTypes.AMAZON_SIGN_IN },
    { name: ButtonTypes.PAYMENT_METHOD_ON_FILE, value: ButtonTypes.PAYMENT_METHOD_ON_FILE }
];

export const AMAZON_SIGNATURE_ALGORITHM = 'AMZN-PAY-RSASSA-PSS';

export const defaultCurrencyMapping = {
    na: "USD",
    eu: "EUR",
    jp: "JPY",
} 

export const CURRENCY_CODES = [
    { name: "AUD", value: "AUD" },
    { name: "CHF", value: "CHF" },
    { name: "DKK", value: "DKK" },
    { name: "EUR", value: "EUR" },
    { name: "GBP", value: "GBP" },
    { name: "HKD", value: "HKD" },
    { name: "JPY", value: "JPY" },
    { name: "NOK", value: "NOK" },
    { name: "NZD", value: "NZD" },
    { name: "SEK", value: "SEK" },
    { name: "USD", value: "USD" },
    { name: "ZAR", value: "ZAR" }
];

export enum ProductTypes  {
    SIGN_IN = 'SignIn',
    PAY_ONLY = 'PayOnly',
    PAY_AND_SHIP = 'PayAndShip'
};

export const SETUP_ONLY = [
    { name: "True", value: "true" },
    { name: "False", value: "false" }
];

export const PRODUCT_TYPES = [
    { name: ProductTypes.PAY_AND_SHIP, value: ProductTypes.PAY_AND_SHIP },
    { name: ProductTypes.PAY_ONLY, value: ProductTypes.PAY_ONLY }
];

export const PLACEMENT_VALUE = [
{ name: "Home", value:"Home" },
{ name: "Product", value: "Product" },
{ name: "Cart", value: "Cart" },
{ name: "Checkout", value: "Checkout" },
{ name: "Other", value: "Other" }
];

export const BUTTON_COLORS = [
    { name: "Gold (default)", value: "Gold" },
    { name: "LightGray", value: "LightGray" },
    { name: "DarkGray", value: "DarkGray" }
];

export const BUTTON_DESIGNS = [
    { name: "Use Your Amazon Account", value: "D0000" },
    { name: "Amazon Pay", value: "C0001" }
];

export const PAYMENT_INTENTS = [
    { name: "Confirm", value: "Confirm" },
    { name: "Authorize", value: "Authorize" },
    { name: "AuthorizeWithCapture", value: "AuthorizeWithCapture" }
];

export const FREQUENCY_UNITS = [
    { name: "Year", value: "Year" },
    { name: "Month", value: "Month" },
    { name: "Week", value: "Week" },
    { name: "Day", value: "Day" },
    { name: "Variable", value: "Variable" }
];

export const CHECKOUT_LANGUAGES = {
    na: [
        { name: "en_US", value: "en_US" }
    ],
    eu: [
        { name: "en_GB", value: "en_GB" },
        { name: "de_DE", value: "de_DE" },
        { name: "fr_FR", value: "fr_FR" },
        { name: "it_IT", value: "it_IT" },
        { name: "es_ES", value: "es_ES" }
    ],
    jp: [
        { name: "ja_JP", value: "ja_JP" }
    ]
};

export enum ApiType  {
    CREATE_CHECKOUT_SESSION = "createCheckoutSession",
    GET_CHECKOUT_SESSION = "getCheckoutSession",
    UPDATE_CHECKOUT_SESSION = "updateCheckoutSession",
    COMPLETE_CHECKOUT_SESSION = "completeCheckoutSession",
    FINALIZE_CHECKOUT_SESSION = "finalizeCheckoutSession",
    GET_CHARGE_PERMISSION = "getChargePermission",
    UPDATE_CHARGE_PERMISSION = "updateChargePermission",
    CLOSE_CHARGE_PERMISSION = "closeChargePermission",
    GET_CHARGE = "getCharge",
    CREATE_CHARGE = "createCharge",
    CAPTURE_CHARGE = "captureCharge",
    CANCEL_CHARGE = "cancelCharge",
    CREATE_REFUND = "createRefund",
    GET_REFUND = "getRefund",
    DELIVERY_TRACKER = "deliveryTracker",
    GET_BUYER = "getBuyer",
    GET_REPORTS = "getReports",
    GET_REPORT_BY_ID = "getReportById",
    CREATE_REPORT = "createReport",
    GET_REPORT_DOCUMENT = "getReportDocument"
};

export enum ApiPath  {
    CHECKOUT_SESSIONS = "sandbox/v2/checkoutSessions",
    CHARGE_PERMISSIONS = "sandbox/v2/chargePermissions",
    CHARGES = "sandbox/v2/charges",
    REFUNDS = "sandbox/v2/refunds",
    BUYERS ="sandbox/v2/buyers",
    DELIVERY_TRACKERS = "sandbox/v2/deliveryTrackers",
    REPORTS = "sandbox/v2/reports",
    REPORT_DOCUMENTS = "sandbox/v2/report-documents"
};

export const ToolTip = {
    "tooltip-trigger-icon" : "info_outline",
    "tooltipPosition" : "bottom",
    "x-amz-pay-idempotency-key" : "Idempotency key to safely retry requests",
    "x-amz-pay-simulation-code" : "Add x-amz-pay-simulation-code request header to your API calls to simulate different behaviors",
    "storeId" : "Amazon Pay store ID. Retrieve this value from Amazon Pay Integration Central: US, EU, JP",
    "chargePermissionType" : `The type of Charge Permission requested. Supported values: 'OneTime', 'Recurring' & 'PaymentMethodOnFile'`,
    "checkoutReviewReturnUrl" : "Amazon Pay will redirect to this URL after the buyer selects their preferred payment instrument and shipping address",
    "checkoutResultReturnUrl" : "Amazon Pay will redirect to this URL after completing the transaction",
    "unit" : "Frequency unit for each billing cycle. Supported values: 'Year', 'Month', 'Week', 'Day', 'Variable'",
    "value" : "Number of frequency units per billing cycle. For example, to specify a weekly cycle set unit to Week and value to 1",
    "amount" : "Transaction amount",
    "currencyCode" : "Transaction currency code in ISO 4217 format. Example: USD",
    "type" : "Specifies whether addresses that match restrictions configuration should or should not be restricted. Supported values: 'Allowed' & 'NotAllowed'",
    "paymentIntent" : "Payment flow for charging the buyer. Supported values: 'Confirm', 'Authorize' & 'AuthorizeWithCapture'",
    "presentmentCurrency" : "The currency that the buyer will be charged in ISO 4217 format. Example: USD",
    "softDescriptor" : "Description shown on the buyer payment instrument statement. Do not store sensitive data such as buyer details in this field.",
    "merchantReferenceId" : "External merchant order identifer. The merchant order identifer is shared in buyer communication and in the buyer transaction history on the Amazon Pay website",
    "merchantStoreName" : "Merchant store name. Setting this parameter will override the default value configured in Seller Central (US, EU, JP). The store name is shared in buyer communication and in the buyer transaction history on the Amazon Pay website",
    "noteToBuyer" : "Description of the order that is shared in buyer communication",
    "customInformation" : "Custom info for the order. This data is not shared in any buyer communication",
    "platformId" : "Merchant identifier of the Solution Provider (SP). Only SPs should use this field",
    "providerMetadata" : "Payment service provider (PSP)-provided order details. Only PSPs should use these fields",
    "checkoutSessionId" : "Checkout Session identifer",
    "chargePermissionId" : "Charge permission identifier returned after Checkout Session is complete",
    "closureReason" : "Merchant-provided reason for closing Charge Permission",
    "chargeId" : "Charge identifier. This value is returned at the end of a completed Checkout Session or you can create a new charge from a Charge Permission in a Chargeable state",
    "cancellationReason" : "Merchant-provided reason for canceling Charge",
    "refundId" : "Refund identifier",
    "trackingNumber" : "The tracking number for the shipment provided by the shipping company",
    "carrierCode" : "The shipping company code used for delivering goods to the customer. Download carrierCode list",
    "buyerToken" : "Token used to retrieve buyer details. This value is appended as a query parameter to signInReturnUrl",
    "signInReturnUrl" : "Amazon Pay will redirect to this URL after the buyer signs in",
    "signInCancelUrl" : "Amazon Pay will redirect to this URL if the buyer cancels sign-in on the Amazon Pay hosted page",
    "signInScopes" : "The buyer details that you're requesting access for. Note that Amazon Pay will always return buyerId even if no values are set for this parameter",
    "merchantId" : "Amazon Pay merchant account identifier",
    "ledgerCurrency" : "Ledger currency provided during registration for the given merchant identifier. Supported values: US merchants - 'USD', EU merchants - 'EUR', UK merchants - 'GBP', JP merchants - 'JPY'",
    "placement" : "Placement of the Amazon Pay button on your website. Supported values: 'Home', 'Product', 'Cart' , 'Checkout' & 'Other'",
    "checkoutLanguage" : "Language used to render the button and text on Amazon Pay hosted pages. Supported values: 'en_US', 'en_GB', de_DE', 'fr_FR', 'it_IT', 'es_ES' & 'ja_JP'",
    "buttonColor" : "Color of the Amazon Pay button. Supported values: 'Gold', 'LightGray', 'DarkGray'",
    "buttonProductType" : "Product type selected for checkout. Supported values: 'PayAndShip', 'PayOnly' & 'SignIn' ",
    "checkoutCancelUrl" : "Amazon Pay will redirect to this URL if the buyer cancels checkout on any Amazon Pay hosted page",
    "chargeAmount" : "Amount to be processed using paymentIntent during checkout",
    "providerReferenceId" : "Payment service provider (PSP)-provided order identifier",
    "totalOrderAmount" : "Total order amount. Must match Checkout Session object paymentDetails",
    "deliverySpecifications" : "Specify shipping restrictions to prevent buyers from selecting unsupported addresses from their Amazon address book",
    "paymentMethodOnFileMetadata" : "Metadata about how payment method on file charge permission will be used. Amazon Pay will use it to get additional information related to payment method on file",
    "channel" : "Only required for chargePermissionType PaymentMethodOnFile, represents the channel of the charge",
    "chargeInitiator" : "Only required for chargePermissionType PaymentMethodOnFile, represents who initiated the charge",
    "reportTypes" : "The type of the report.",
    "processingStatuses" : "The processing status of the report.",
    "createdSince" : "The earliest report creation date and time for reports to include in the response, in ISO 8601 date time format. Reports are retained for a maximum of 90 days.",
    "createdUntil" : "The latest report creation date and time for reports to include in the response, in ISO 8601 date time format. Reports are retained for a maximum of 90 days.",
    "pageSize" : "The number of reports per page to return.",
    "nextToken" : "A string token returned in the response to your previous request. nextToken is returned when the number of results exceeds the specified pageSize value. To get the next page of results, call the getReports operation and include this token as the only parameter. Specifying nextToken with any other parameters will cause the request to fail.",
    "reportId" : "The report identifier.",
    "reportType" : "The type of the report.",
    "startTime" : "Time from which the transactions are included in the report.",
    "endTime" : "Time to which the transactions are included in the report.",
    "reportDocumentId" : "The report document identifier.",
    "canHandlePendingAuthorization" : "Boolean that indicates whether merchant can handle pending response",
    "shippingAddress" : "Shipping address provided by Amazon for validation",
    "billingAddress" : "Billing address provided by Amazon for validation",
    "supplementaryData" : "Supplementary data about your order",
    "name" : "Address name",
    "addressLine1" : "The first line of the address",
    "addressLine2" : "The second line of the address",
    "addressLine3" : "The third line of the address",
    "city" : "City of the address",
    "county" : "County of the address",
    "district" : "District of the address",
    "stateOrRegion" : "The state or region",
    "postalCode" : "Postal code of the address",
    "countryCode" : "Country code of the address in ISO 3166 format",
    "phoneNumber" : "Phone number"
}

export const AUDIT_API_URL = {
    development: 'https://44ntoywst3.execute-api.us-west-2.amazonaws.com',
    production: 'https://fe2wqglwk1.execute-api.us-east-1.amazonaws.com'
};

export const COGNITO_POOL_ID = {
    development: 'us-west-2:a8ae44e3-050c-42ab-81f1-5e8a18cb77a1', 
    production: 'us-east-1:f0161ec3-17d5-42f8-8166-ab8521c4fdaf'
}

export const AWS_REGION = {
    development: 'us-west-2',
    production: 'us-east-1'
}

export const PMOF_JSON_RESPONSE = `{
    "webCheckoutDetails": {
        "checkoutReviewReturnUrl": "https://amazon.com/checkout-review",
        "checkoutResultReturnUrl": "https://amazon.com/checkout-result",
        "checkoutCancelUrl": "https://amazon.com/checkout-cancel"
    },
    "storeId": "store456",
    "chargePermissionType": "PaymentMethodOnFile",
    "deliverySpecifications": {
        "specialRestrictions": [
            "RestrictPOBoxes"
        ],
        "addressRestrictions": {
            "type": "Allowed",
            "restrictions": {
                "US": {
                    "statesOrRegions": [
                        "WA"
                    ]
                }
            }
        }
    },
    "scopes": [
        "name",
        "email",
        "phoneNumber",
        "billingAddress"
    ],
    "paymentDetails": {
        "paymentIntent": "Authorize",
        "canHandlePendingAuthorization": true,
        "presentmentCurrency": "JPY",
        "softDescriptor": "on credit card",
        "allowOvercharge": true,
        "extendExpiration": true,
        "chargeAmount": {
            "amount": "2.34",
            "currencyCode": "GBP"
        },
        "totalOrderAmount": {
            "amount": "3.45",
            "currencyCode": "NZD"
        }
    },
    "merchantMetadata": {
        "merchantReferenceId": "ref id",
        "merchantStoreName": "store name",
        "noteToBuyer": "thank you for your purchase",
        "customInformation": "this is custom information",
        "platformId": "platform123"
    },
    "providerMetadata": {
        "providerReferenceId": "provider123"
    },
    "paymentMethodOnFileMetadata": {
        "setupOnly": true
    }
}`;

export const APB_WITH_RECURRING_AND_PAYANDSHIP_JSON_RESPONSE = `{
    "webCheckoutDetails": {
        "checkoutResultReturnUrl": "https://amazon.com/checkout-result",
        "checkoutCancelUrl": "https://amazon.com/checkout-cancel",
        "checkoutMode": "ProcessOrder"
    },
    "storeId": "store456",
    "chargePermissionType": "Recurring",
    "scopes": [
        "name",
        "email",
        "phoneNumber",
        "billingAddress"
    ],
    "recurringMetadata": {
        "amount": {
            "amount": "1.23",
            "currencyCode": "EUR"
        },
        "frequency": {
            "unit": "Variable",
            "value": "1"
        }
    },
    "addressDetails": {
        "name": "Buyer Name",
        "addressLine1": "line 1",
        "addressLine2": "line 2",
        "addressLine3": "line 3",
        "city": "Seattle",
        "districtOrCounty": "KING",
        "stateOrRegion": "WA",
        "postalCode": "98109",
        "countryCode": "US",
        "phoneNumber": "2065551212"
    },
    "paymentDetails": {
        "paymentIntent": "Authorize",
        "canHandlePendingAuthorization": true,
        "presentmentCurrency": "JPY",
        "softDescriptor": "on credit card",
        "chargeAmount": {
            "amount": "2.34",
            "currencyCode": "GBP"
        }
    },
    "merchantMetadata": {
        "merchantReferenceId": "ref id",
        "merchantStoreName": "store name",
        "noteToBuyer": "thank you for your purchase",
        "customInformation": "this is custom information",
        "platformId": "platform123"
    },
    "providerMetadata": {
        "providerReferenceId": "provider123"
    }
}`;

export const APB_WITH_RECURRING_AND_PAYONLY_JSON_RESPONSE = `{
    "webCheckoutDetails": {
        "checkoutResultReturnUrl": "https://amazon.com/checkout-result",
        "checkoutCancelUrl": "https://amazon.com/checkout-cancel",
        "checkoutMode": "ProcessOrder"
    },
    "storeId": "store456",
    "chargePermissionType": "Recurring",
    "scopes": [
        "name",
        "email",
        "phoneNumber",
        "billingAddress"
    ],
    "recurringMetadata": {
        "amount": {
            "amount": "1.23",
            "currencyCode": "EUR"
        },
        "frequency": {
            "unit": "Variable",
            "value": "1"
        }
    },
    "paymentDetails": {
        "paymentIntent": "Authorize",
        "canHandlePendingAuthorization": true,
        "presentmentCurrency": "JPY",
        "softDescriptor": "on credit card",
        "chargeAmount": {
            "amount": "2.34",
            "currencyCode": "GBP"
        }
    },
    "merchantMetadata": {
        "merchantReferenceId": "ref id",
        "merchantStoreName": "store name",
        "noteToBuyer": "thank you for your purchase",
        "customInformation": "this is custom information",
        "platformId": "platform123"
    },
    "providerMetadata": {
        "providerReferenceId": "provider123"
    }
}`;

export const APB_WITH_ONETIME_AND_PAYANDSHIP_JSON_RESPONSE = `{
    "webCheckoutDetails": {
        "checkoutResultReturnUrl": "https://amazon.com/checkout-result",
        "checkoutCancelUrl": "https://amazon.com/checkout-cancel",
        "checkoutMode": "ProcessOrder"
    },
    "storeId": "store456",
    "chargePermissionType": "OneTime",
    "scopes": [
        "name",
        "email",
        "phoneNumber",
        "billingAddress"
    ],
    "addressDetails": {
        "name": "Buyer Name",
        "addressLine1": "line 1",
        "addressLine2": "line 2",
        "addressLine3": "line 3",
        "city": "Seattle",
        "districtOrCounty": "KING",
        "stateOrRegion": "WA",
        "postalCode": "98109",
        "countryCode": "US",
        "phoneNumber": "2065551212"
    },
    "paymentDetails": {
        "paymentIntent": "Authorize",
        "canHandlePendingAuthorization": true,
        "presentmentCurrency": "JPY",
        "softDescriptor": "on credit card",
        "allowOvercharge": true,
        "extendExpiration": true,
        "chargeAmount": {
            "amount": "2.34",
            "currencyCode": "GBP"
        },
        "totalOrderAmount": {
            "amount": "3.45",
            "currencyCode": "NZD"
        }
    },
    "merchantMetadata": {
        "merchantReferenceId": "ref id",
        "merchantStoreName": "store name",
        "noteToBuyer": "thank you for your purchase",
        "customInformation": "this is custom information",
        "platformId": "platform123"
    },
    "providerMetadata": {
        "providerReferenceId": "provider123"
    }
}`;

export const APB_WITH_ONETIME_AND_PAYONLY_JSON_RESPONSE = `{
    "webCheckoutDetails": {
        "checkoutResultReturnUrl": "https://amazon.com/checkout-result",
        "checkoutCancelUrl": "https://amazon.com/checkout-cancel",
        "checkoutMode": "ProcessOrder"
    },
    "storeId": "store456",
    "chargePermissionType": "OneTime",
    "scopes": [
        "name",
        "email",
        "phoneNumber",
        "billingAddress"
    ],
    "paymentDetails": {
        "paymentIntent": "Authorize",
        "canHandlePendingAuthorization": true,
        "presentmentCurrency": "JPY",
        "softDescriptor": "on credit card",
        "allowOvercharge": true,
        "extendExpiration": true,
        "chargeAmount": {
            "amount": "2.34",
            "currencyCode": "GBP"
        },
        "totalOrderAmount": {
            "amount": "3.45",
            "currencyCode": "NZD"
        }
    },
    "merchantMetadata": {
        "merchantReferenceId": "ref id",
        "merchantStoreName": "store name",
        "noteToBuyer": "thank you for your purchase",
        "customInformation": "this is custom information",
        "platformId": "platform123"
    },
    "providerMetadata": {
        "providerReferenceId": "provider123"
    }
}`;

export const SIGNIN_JSON_RESPONSE = `{
    "signInReturnUrl": "https://amazon.com/signin-return",
    "signInCancelUrl": "https://amazon.com/signin-cancel",
    "storeId": "store123",
    "signInScopes": [
        "name",
        "email",
        "phoneNumber",
        "shippingAddress",
        "billingAddress",
        "postalCode"
    ]
}`;

export const RECURRING_JSON_RESPONSE = `{
    "webCheckoutDetails": {
        "checkoutReviewReturnUrl": "https://amazon.com/checkout-review",
        "checkoutResultReturnUrl": "https://amazon.com/checkout-result",
        "checkoutCancelUrl": "https://amazon.com/checkout-cancel"
    },
    "storeId": "store456",
    "chargePermissionType": "Recurring",
    "deliverySpecifications": {
        "specialRestrictions": [
            "RestrictPOBoxes"
        ],
        "addressRestrictions": {
            "type": "Allowed",
            "restrictions": {
                "US": {
                    "statesOrRegions": [
                        "WA"
                    ]
                }
            }
        }
    },
    "scopes": [
        "name",
        "email",
        "phoneNumber",
        "billingAddress"
    ],
    "recurringMetadata": {
        "amount": {
            "amount": "1.23",
            "currencyCode": "EUR"
        },
        "frequency": {
            "unit": "Variable",
            "value": "1"
        }
    },
    "paymentDetails": {
        "paymentIntent": "Authorize",
        "canHandlePendingAuthorization": true,
        "presentmentCurrency": "JPY",
        "softDescriptor": "on credit card",
        "chargeAmount": {
            "amount": "2.34",
            "currencyCode": "GBP"
        }
    },
    "merchantMetadata": {
        "merchantReferenceId": "ref id",
        "merchantStoreName": "store name",
        "noteToBuyer": "thank you for your purchase",
        "customInformation": "this is custom information",
        "platformId": "platform123"
    },
    "providerMetadata": {
        "providerReferenceId": "provider123"
    }
}`;

export const ONETIME_JSON_RESPONSE = `{
    "webCheckoutDetails": {
        "checkoutReviewReturnUrl": "https://amazon.com/checkout-review",
        "checkoutResultReturnUrl": "https://amazon.com/checkout-result",
        "checkoutCancelUrl": "https://amazon.com/checkout-cancel"
    },
    "storeId": "store456",
    "chargePermissionType": "OneTime",
    "deliverySpecifications": {
        "specialRestrictions": [
            "RestrictPOBoxes"
        ],
        "addressRestrictions": {
            "type": "Allowed",
            "restrictions": {
                "US": {
                    "statesOrRegions": [
                        "WA"
                    ]
                }
            }
        }
    },
    "scopes": [
        "name",
        "email",
        "phoneNumber",
        "billingAddress"
    ],
    "paymentDetails": {
        "paymentIntent": "Authorize",
        "canHandlePendingAuthorization": true,
        "presentmentCurrency": "JPY",
        "softDescriptor": "on credit card",
        "allowOvercharge": true,
        "extendExpiration": true,
        "chargeAmount": {
            "amount": "2.34",
            "currencyCode": "GBP"
        },
        "totalOrderAmount": {
            "amount": "3.45",
            "currencyCode": "NZD"
        }
    },
    "merchantMetadata": {
        "merchantReferenceId": "ref id",
        "merchantStoreName": "store name",
        "noteToBuyer": "thank you for your purchase",
        "customInformation": "this is custom information",
        "platformId": "platform123"
    },
    "providerMetadata": {
        "providerReferenceId": "provider123"
    }
}`;

export const createCheckoutSessionRequest = {
    "header": {
        "x-amz-pay-idempotency-key": "Unique Key Value"
    },
    "payload": {
        "webCheckoutDetails": {
            "checkoutReviewReturnUrl": "https://a.com/merchant-review-page"
        },
        "storeId": "amzn1.application-oa2-client.8b5e45312b5248b69eeaStoreId",
        "paymentMethodOnFileMetadata": {
            "setupOnly": true
        },
        "paymentDetails": {
            "paymentIntent": "Confirm"
        }
    }
};

export const createChargeRequest = {
    "header" : {
      "x-amz-pay-idempotency-key": "Unique key value"
    },
    "payload": {
      "chargePermissionId": "P21-1111111-1111111",
      "chargeAmount": {
        "amount": "14.00",
        "currencyCode": "USD"
      },
      "captureNow": true,
      "softDescriptor": "Descriptor",
      "canHandlePendingAuthorization": false,
      "channel": "Web",
      "chargeInitiator": "CITU"
    }
  };